import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  // Id da entidade selecionada. Esse é o dado que enviamos e armazenamos no cookie
  idEntidade: null,
  // entidade selecionada
  entidade: null,
  // lista de entidades disponíveis para o usuário
  entidades: [],
  loading: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
